import { STRIKING_CATEGORIES } from '../../../data/constants';

export default function StrikingTechniquesEditor({ techniques, onChange }) {
    const update = (i, key, val) =>
        onChange(techniques.map((t, idx) => idx === i ? { ...t, [key]: val } : t));
    const add = () => onChange([...techniques, { name: '', category: '', point: '', result: '', position: '' }]);
    const remove = i => onChange(techniques.filter((_, idx) => idx !== i));

    return (
        <>
            {techniques.map((t, i) => (
                <div key={i} style={{ marginBottom: 12, padding: '12px 14px', background: 'var(--bg2)', borderRadius: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <span style={{ fontSize: 12, color: 'var(--text3)', minWidth: 20 }}>#{i + 1}</span>
                        <input
                            className="form-input"
                            style={{ flex: 1 }}
                            placeholder="기술명 (예: 잽, 로우킥)"
                            value={t.name}
                            onChange={e => update(i, 'name', e.target.value)}
                        />
                        {techniques.length > 1 && (
                            <button className="remove-btn" onClick={() => remove(i)}>×</button>
                        )}
                    </div>
                    <div style={{ display: 'flex', gap: 6, marginBottom: 8, flexWrap: 'wrap' }}>
                        {STRIKING_CATEGORIES.map(cat => (
                            <button key={cat}
                                className={`toggle-btn ${t.category === cat ? 'active' : ''}`}
                                style={{ padding: '4px 10px', fontSize: 11, flex: 'none' }}
                                onClick={() => update(i, 'category', t.category === cat ? '' : cat)}
                            >{cat}</button>
                        ))}
                    </div>
                    <textarea
                        className="form-input"
                        rows={2}
                        placeholder="포인트 (예: 잽으로 거리 재고 우측 훅 연계)"
                        value={t.point}
                        onChange={e => update(i, 'point', e.target.value)}
                        style={{ resize: 'none' }}
                    />
                </div>
            ))}
            <button className="add-set-btn" style={{ width: '100%' }} onClick={add}>+ 기술 추가</button>
        </>
    );
}
